import { render } from "./CopyPopover.vue?vue&type=template&id=0e57ef70&scoped=true"
import script from "./CopyPopover.vue?vue&type=script&lang=js"
export * from "./CopyPopover.vue?vue&type=script&lang=js"

import "./CopyPopover.vue?vue&type=style&index=0&id=0e57ef70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e57ef70"],['__file',"src/components/CopyPopover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e57ef70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e57ef70', __exports__)) {
    api.reload('0e57ef70', __exports__)
  }
  
  module.hot.accept("./CopyPopover.vue?vue&type=template&id=0e57ef70&scoped=true", () => {
    api.rerender('0e57ef70', render)
  })

}


export default __exports__